<!-- Button -->
<button
  mat-icon-button
  [matMenuTriggerFor]="userActions">
  <span class="relative">
    @if (showAvatar && user.profileImage) {
      <img
        class="w-7 h-7 rounded-full"
        [src]="getUserImageUrl()">
    }
    @if (!showAvatar || !user.profileImage) {
      <mat-icon
      [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    }
  </span>
</button>

<mat-menu
  [xPosition]="'before'"
  #userActions="matMenu">
  <ng-container *transloco="let t">
    <button mat-menu-item>
      <span class="flex flex-col leading-none">
        <span>{{ t('signedInAs') }}</span>
        <span class="mt-1.5 text-md font-medium">{{user.displayName}}</span>
      </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
      mat-menu-item
      (click)="signOut()">
      <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
      <span>{{ t('signOut') }}</span>
    </button>
  </ng-container>
</mat-menu>
